import React from "react";
import { Stack, Typography } from "@mui/material";
import { MdErrorOutline } from "react-icons/md";

type Props = {
  errorMsg?: string;
  // Smaller icon/typography for nested contexts (a card section, a small
  // panel) where the full-page treatment would look oversized/out of place.
  dense?: boolean;
};

const ErrorSection = ({ errorMsg = "", dense = false }: Props) => {
  if (dense) {
    return (
      <Stack alignItems="center" justifyContent="center" gap="8px" sx={{ py: 3 }}>
        <MdErrorOutline size={32} color="var(--mui-palette-error-main)" />
        <Typography variant="subtitle2" color="error.main">
          حدث خطأ
        </Typography>
        {errorMsg && (
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {errorMsg}
          </Typography>
        )}
      </Stack>
    );
  }

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap="16px"
      marginTop="3rem"
    >
      <MdErrorOutline size={128} color="var(--mui-palette-error-main)" />
      <Typography variant="h3" color="error.main">
        حدث خطأ
      </Typography>
      <Typography variant="h4">{errorMsg}</Typography>
    </Stack>
  );
};

export default ErrorSection;
